import config from "../config";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import CustomersAndPetsComponent from "../components/CustomersAndPetsComponent";
import { ListActionProvider } from "../actions/list/ListActionContext";
import configCustomersAndPets from "../configCustomersAndPets";
import { EditActionProvider } from "../actions/edit/EditActionContext";

function CustomersAndPetsPage() {

  const tablePageParams = {
    modelConfig: configCustomersAndPets, // Configuración del modelo
    formDefaultValues: null,
    filters: null,
    formFilterValues: null,
  }

  return (
    <ListActionProvider key="customers-and-pets">
      <RemoveActionProvider>
          <EditActionProvider>
            <CustomersAndPetsComponent
              {...tablePageParams}
            />
          </EditActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default CustomersAndPetsPage;
